module.exports = __webpack_public_path__ + "img/beijing.3a417e81.png";